// Product Bundle Card Component - handles bundle variant switching
class ProductBundleCard extends HTMLElement {
  constructor() {
    super();
    this.bundleButtons = null;
    this.bottomSections = null;
    this.imageSections = null;
    this.mobileQuickAddSections = null;
    this.currentBundleSize = null;
  }

  connectedCallback() {
    this.initializeElements();
    this.attachEventListeners();
  }

  initializeElements() {
    this.bundleButtons = this.querySelectorAll('.bundle-variant-button');
    this.bottomSections = this.querySelectorAll('.bundle-bottom-section');
    this.imageSections = this.querySelectorAll('.bundle-image-section');
    this.mobileQuickAddSections = this.querySelectorAll('.bundle-mobile-quick-add');
    
    const activeButton = this.querySelector('.bundle-variant-button.current-product');
    if (activeButton) {
      this.currentBundleSize = activeButton.getAttribute('data-bundle-size');
    } else {
      console.error('No active bundle variant button found.');
    }
  }

  attachEventListeners() {
    this.bundleButtons.forEach(button => {
      button.addEventListener('click', this.handleBundleSwitch.bind(this));
    });

    document.addEventListener('visibilitychange', this.handleVisibilityChange.bind(this));
  }

  handleBundleSwitch(event) {
    event.preventDefault();
    event.stopPropagation();
    
    const clickedButton = event.target;
    const bundleSize = clickedButton.getAttribute('data-bundle-size');
    
    if (bundleSize === this.currentBundleSize) return; 
    
    this.switchToBundle(bundleSize, clickedButton);
  }

  switchToBundle(bundleSize, clickedButton) {
    this.updateButtonStates(clickedButton);
    
    this.updateSectionVisibility(bundleSize);
    
    this.currentBundleSize = bundleSize;
  }

  updateButtonStates(activeButton) {
    this.bundleButtons.forEach(btn => {
      btn.classList.remove('current-product');
      btn.classList.add('product-link');
      btn.setAttribute('aria-pressed', 'false');
      btn.setAttribute('aria-selected', 'false');
    });
    
    activeButton.classList.add('current-product');
    activeButton.classList.remove('product-link');
    activeButton.setAttribute('aria-pressed', 'true');
    activeButton.setAttribute('aria-selected', 'true');
  }

  updateSectionVisibility(bundleSize) {
    this.bottomSections.forEach(section => {
      if (section.getAttribute('data-bundle-size') === bundleSize) {
        section.style.display = 'block';
        section.setAttribute('aria-hidden', 'false');
      } else {
        section.style.display = 'none';
        section.setAttribute('aria-hidden', 'true');
      }
    });

    this.imageSections.forEach(imageSection => {
      if (imageSection.getAttribute('data-bundle-size') === bundleSize) {
        imageSection.style.display = 'block';
        imageSection.setAttribute('aria-hidden', 'false');
        imageSection.setAttribute('tabindex', '0');
      } else {
        imageSection.style.display = 'none';
        imageSection.setAttribute('aria-hidden', 'true');
        imageSection.setAttribute('tabindex', '-1');
      }
    });

    this.mobileQuickAddSections.forEach(mobileSection => {
      if (mobileSection.getAttribute('data-bundle-size') === bundleSize) {
        mobileSection.style.display = 'block';
        mobileSection.setAttribute('aria-hidden', 'false');
      } else {
        mobileSection.style.display = 'none';
        mobileSection.setAttribute('aria-hidden', 'true');
      }
    });
  }

  handleVisibilityChange() {
    if (!document.hidden) {
      this.bundleButtons.forEach(button => {
        button.style.pointerEvents = 'auto';
        button.removeAttribute('disabled');
      });
    }
  }
}

if (!customElements.get('product-bundle-card')) {
  customElements.define('product-bundle-card', ProductBundleCard);
}